import { createGlobalStyle } from 'styled-components';

export interface UIKitGlobalStyleInterface {
    /**
     * CDN path
     */
    endpoint: string,
}

export const UIKitGlobalStyle = createGlobalStyle<UIKitGlobalStyleInterface>`
    @font-face {
        font-family: 'R1Custom';
        font-display: swap;
        src: url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.eot');
        src: url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.eot?#iefix') format('embedded-opentype'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.woff2') format('woff2'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.woff') format('woff'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Regular.ttf') format('truetype');
        font-weight: 100 400;
    }

    @font-face {
        font-family: 'R1Custom';
        font-display: swap;
        src: url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.eot');
        src: url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.eot?#iefix') format('embedded-opentype'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.woff2') format('woff2'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.woff') format('woff'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Medium.ttf') format('truetype');
        font-weight: 500;
    }

    @font-face {
        font-family: 'R1Custom';
        font-display: swap;
        src: url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.eot');
        src: url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.eot?#iefix') format('embedded-opentype'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.woff2') format('woff2'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.woff') format('woff'),
        url('${props => props.endpoint}/static/fonts/CoFo_Sans-Bold.ttf') format('truetype');
        font-weight: 600 900;
    }
`;

export default UIKitGlobalStyle;
